import React from 'react';

interface AnalyticsPageHeaderProps {
  title: string;
}

export default class AnalyticsHeader extends React.Component<AnalyticsPageHeaderProps, any> {
  static defaultProps = {
    title: '',
  }

  render() {
    return (
      <div className="header">
        <h2>
          {this.props.title}
        </h2>
        <p className="pull-right">
          Last 30 Days
        </p>
      </div>
    );
  }
}
